"use client";
import React from "react";

export interface TechnologyHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

export default function TechnologyHeader({
  title,
  description,
  className = "",
}: TechnologyHeaderProps) {
  return (
    <>
      <p className="justify-center text-[#636363] text-base font-medium uppercase tracking-tight pb-4">Tech Stack</p>
      <div
        className={`technology-header flex flex-col lg:flex-row items-start gap-[15px] w-full lg:w-auto ${className}`}
      >
        <div className="technology-header-left w-full lg:w-auto leading-[110%]">
          <h2 className="self-stretch justify-start text-[length:var(--section-title)] font-medium clash-font min-w-[14ch]">
            <span className="text-[#00040b] capitalize leading-[110%]">
              {title}
            </span>
          </h2>
        </div>

        <div className="technology-header-right relative">
          <div className="w-full lg:max-w-[60ch] text-[#00040b]/70 text-[length:var(--hero-para)] font-normal leading-[150%]">
            {description}
          </div>
        </div>
      </div>
    </>
  );
}
